import { BaseSearchDTO } from "../../../../uinspect/src/app/global/interfaces/index";

export interface ExternalEventSearchDTO extends BaseSearchDTO
{
  filters?: {
    externalId?: string,
    eventSource?: string,
  };
}
